import {
  EventEmitter,
  Input,
  OnChanges,
  Output,
  Renderer2,
} from "@angular/core";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { BcLedgerStacker } from "../../../../core/models/bcLedgers/bcLedgerStacker";
import { YtdBacklogData } from "../../../../core/models/bcLedgers/ytdbacklog/YtdBacklogData";
import { LoaderService } from "../../../../core/services/loader.service";
import { exportExcel } from "../../../../core/services/shared.service";
import { TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { BcledgerService } from "../../../../core/services/bcledger.service";
import { YtdBacklogRequest } from "../../../../core/models/bcLedgers/ytdbacklog/YtdBacklogRequest";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { ClientDetailsComponent } from "../../../clients/components/client-details/client-details.component";

@UntilDestroy()
@Component({
  selector: "jni-backlog-details",
  templateUrl: "./backlog-details.component.html",
  styleUrls: ["./backlog-details.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    HidedynamicsdatePipe,
    ModalStackerComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
    ClientDetailsComponent,
  ],
})
export class BacklogDetailsComponent implements OnInit, OnChanges {
  backlogDetailsLists: YtdBacklogData[] = [];
  @Input() bcLedgerStacker!: BcLedgerStacker;
  bcledgerFilter!: YtdBacklogRequest;
  fileName = "Backlog Details";
  clientDisplayModal = false;
  customerId = "";
  @Output() closeModalEvent = new EventEmitter();

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _toastr: JniToastrService,
    private _backlogDetailsService: BcledgerService,
    private _loaderService: LoaderService,
    private renderer: Renderer2
  ) {
    this._route.params.subscribe(params => {
      this.bcledgerFilter = { ...params } as YtdBacklogRequest;
      this.bcledgerFilter.CategoryID = "";
    });
  }

  ngOnInit(): void {
    this.getBacklogDetailsData();
  }

  getBacklogDetailsData() {
    this._loaderService.setLoaderState(true);
    this._backlogDetailsService
      .getBacklogDetailsData(this.bcledgerFilter)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data.Data) {
            this.backlogDetailsLists = res.data.Data;
          } else {
            this._toastr.error("Error", res.message ?? "No results found");
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message ?? "No results found");
        },
      });
  }

  exportExcelFile() {
    exportExcel(this.backlogDetailsLists, this.fileName);
  }

  ngOnChanges() {
    if (this.bcLedgerStacker) {
      this.bcledgerFilter = { ...this.bcLedgerStacker };
      this.bcledgerFilter.CategoryID = "";
    }
  }

  redirectToSummary(saleOrderId: string) {
    this._router.navigate(["orders/order-summary/" + saleOrderId]);
  }

  redirectToClientSummary(clientId: string) {
    this.customerId = clientId;
    this.clientDisplayModal = true;
    //  this._router.navigate(['clients/active/client-details/' + clientId]);
  }

  closeModal() {
    this.clientDisplayModal = false;
  }

  closeModalOnRedirection() {
    this.clientDisplayModal = false;
  }

  addScollHiddenClass() {
    //if (this.modal) {
    this.renderer.addClass(document.body, "p-overflow-hidden");

    //}
  }

  onCloseModalEvent() {
    this.closeModalEvent.emit();
  }
}
